const en = {
  title: 'Component Stock',
  subtitle: 'Ready-to-use stock of buildable components (e.g. LMTs) -- correct counts here without touching raw parts stock',
  ready: 'Stock',
  emptyTitle: 'No component templates yet',
  emptyMessage: 'Flag a template as "buildable component" in Equipment Templates to see its stock here.',
  failedToLoad: 'Failed to load component stock: {{error}}',
  failedToUpdate: 'Failed to update stock: {{error}}',
  searchingFor: 'Searching for:',
  allCategories: 'All Categories',
  allBrands: 'All Brands',
  history: 'History',
  historyTitle: 'Stock history: {{name}}',
  historyEmpty: 'No changes recorded yet. History is recorded from now on.',
  failedToLoadHistory: 'Failed to load history: {{error}}',
  colDate: 'Date',
  colType: 'Type',
  colChange: 'Change',
  colBeforeAfter: 'Before → After',
  colUser: 'User',
  colNotes: 'Notes',
  type_produced: 'Produced',
  type_consumed: 'Consumed',
  type_returned: 'Returned',
  type_manual: 'Manual correction',
};

const de = {
  title: 'Komponentenlager',
  subtitle: 'Einsatzbereiter Bestand baubarer Komponenten (z. B. LMTs) -- Bestände hier korrigieren, ohne das Teilelager zu verändern',
  ready: 'Bestand',
  emptyTitle: 'Noch keine Komponentenvorlagen',
  emptyMessage: 'Markieren Sie eine Vorlage in den Ausrüstungsvorlagen als „baubare Komponente", um deren Bestand hier zu sehen.',
  failedToLoad: 'Komponentenlager konnte nicht geladen werden: {{error}}',
  failedToUpdate: 'Bestand konnte nicht aktualisiert werden: {{error}}',
  searchingFor: 'Suche nach:',
  allCategories: 'Alle Kategorien',
  allBrands: 'Alle Marken',
  history: 'Verlauf',
  historyTitle: 'Bestandsverlauf: {{name}}',
  historyEmpty: 'Noch keine Änderungen erfasst. Der Verlauf wird ab jetzt aufgezeichnet.',
  failedToLoadHistory: 'Verlauf konnte nicht geladen werden: {{error}}',
  colDate: 'Datum',
  colType: 'Art',
  colChange: 'Änderung',
  colBeforeAfter: 'Vorher → Nachher',
  colUser: 'Benutzer',
  colNotes: 'Notizen',
  type_produced: 'Produziert',
  type_consumed: 'Verbraucht',
  type_returned: 'Zurückgebucht',
  type_manual: 'Manuelle Korrektur',
};

const componentStock = { en, de };
export default componentStock;
